document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  new Swiper('.vide-swiper', {
    slidesPerView: 2.2,
    spaceBetween: 20,
    breakpoints: {
      768: { slidesPerView: 3.2, spaceBetween: 24 },
      1024: { slidesPerView: 4.2, spaceBetween: 24 }
    },
    navigation: {
      nextEl: '.vide-swiper-next',
      prevEl: '.vide-swiper-prev'
    }
  });
});